(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion-list"] && !Shopify.designMode) return;
  try {
    class AccordionPillItem extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.accordion-item__trigger');
      this.trigger?.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const isOpen = this.classList.toggle('is-open');
      this.trigger?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  customElements.define('accordion-pill-item', AccordionPillItem);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-bundle-pack-select]');
    if (!select) return;

    const option = select.selectedOptions[0];
    const button = select.closest('[data-bundle-card]')?.querySelector('[data-bundle-add]');
    if (!option || !button) return;

    button.dataset.variantId = option.value;
    button.dataset.price = option.dataset.price;
    button.dataset.subscribePrice = option.dataset.subscribePrice || '';
    button.dataset.title = option.dataset.title;
    button.disabled = option.disabled;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-item"] && !Shopify.designMode) return;
  try {
    class FaqPillItem extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.faq-item__trigger');
      this.trigger?.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const isOpen = this.classList.toggle('is-open');
      this.trigger?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  customElements.define('faq-pill-item', FaqPillItem);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gallery-video"] && !Shopify.designMode) return;
  try {
    const videoMinimalReady = customElements.get('video-player')
    ? Promise.resolve()
    : import('https://cdn.jsdelivr.net/npm/@videojs/html/cdn/video-minimal.js');

  // video-minimal-skin renders into an open Shadow DOM with no exposed ::part()
  // hooks, so these can only be hidden by reaching into shadowRoot directly —
  // a light-DOM stylesheet can never select them.
  // Video.js's own play button is replaced by our bespoke center icon below,
  // so it's suppressed permanently rather than revealed after first play.
  const HIDDEN_ALWAYS = [
    '#settings-trigger',
    '#settings-menu',
    'media-pip-button',
    '.media-overlay',
    'media-play-button',
    '#play-tooltip',
    '.media-status-indicator--playback',
    '.media-time-controls',
  ];
  // Shown only while actively playing — hidden any time the video is
  // paused, not just before the first play.
  const HIDDEN_WHILE_PAUSED = [
    'media-mute-button',
    '#video-volume-popover',
    'media-captions-button',
    'media-cast-button',
    'media-airplay-button',
    'media-fullscreen-button',
  ];

  function hide(el) {
    el?.style.setProperty('display', 'none', 'important');
  }

  function show(el) {
    el?.style.removeProperty('display');
  }

  class GalleryVideoPlayer extends HTMLElement {
    async connectedCallback() {
      this.video = this.querySelector('[data-gallery-video]');
      if (!this.video) return;

      this.playButton = this.querySelector('[data-gallery-video-play]');

      this.video.addEventListener('play', () => {
        if (this.playButton) this.playButton.hidden = true;
      });

      this.video.addEventListener('pause', () => {
        if (this.playButton) this.playButton.hidden = false;
      });

      // This button sits outside <video-player>, so clicking it never enters
      // media-container's composed path — no conflict with Video.js's own
      // click gesture (unlike a listener placed directly on the video).
      this.playButton?.addEventListener('click', () => this.video.play());

      // Video.js's own Gesture component already handles mouse clicks
      // (togglePaused, region: center) via media-container — adding our own
      // 'click' handler on top of that double-handles the same click and
      // causes play() immediately followed by an unwanted pause(). Its touch
      // gesture only toggles controls though, never playback, so tapping the
      // video on mobile would otherwise do nothing once already playing (no
      // pause) and, with the play button hidden pre-play, nothing to start
      // playback either — hence this handles both directions, scoped to
      // touch/pen pointers only so it never fights the mouse gesture above.
      this.video.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse') return;
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });

      // Video.js fullscreens <media-container> (inside the shadow tree), not
      // the <video> itself — so document.fullscreenElement retargets to the
      // shadow host, <video-minimal-skin>, per the standard shadow DOM
      // retargeting rules. object-cover crops a portrait video to fill the
      // card; switch to object-contain in fullscreen so the whole frame
      // stays visible instead of being cropped against the fullscreen frame.
      const skinHost = this.querySelector('video-minimal-skin');
      document.addEventListener('fullscreenchange', () => {
        const isFullscreen = document.fullscreenElement === skinHost;
        this.video.classList.toggle('object-contain', isFullscreen);
        this.video.classList.toggle('object-cover', !isFullscreen);
      });

      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) this.video.pause();
          }
        },
        { threshold: 0.5 },
      );
      this.visibilityObserver.observe(this);

      await videoMinimalReady;
      const root = this.querySelector('video-minimal-skin')?.shadowRoot;
      if (!root) return;

      HIDDEN_ALWAYS.forEach((selector) => hide(root.querySelector(selector)));

      HIDDEN_WHILE_PAUSED.forEach((selector) => hide(root.querySelector(selector)));
      this.video.addEventListener('play', () => HIDDEN_WHILE_PAUSED.forEach((selector) => show(root.querySelector(selector))));
      this.video.addEventListener('pause', () => HIDDEN_WHILE_PAUSED.forEach((selector) => hide(root.querySelector(selector))));
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
    }
  }

  customElements.define('gallery-video-player', GalleryVideoPlayer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["media-testimonial"] && !Shopify.designMode) return;
  try {
    class MediaTestimonialVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-testimonial-video]');
      this.playButton = this.querySelector('[data-testimonial-play]');

      this.playButton?.addEventListener('click', () => {
        if (!this.video) return;
        this.video.setAttribute('controls', '');
        this.video.play();
        this.playButton.hidden = true;
      });
    }
  }

  customElements.define('media-testimonial-video', MediaTestimonialVideo);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dotlottie-wc')) {
    import('https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-wc@0.9.25/dist/dotlottie-wc.js');
  }
  } catch(e) { console.error(e); }
})();

})();
